module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-propose-planning-bf6112d3d4961aabea8c5fad966cf04f.jpg";